class PostingdropdownController {
  constructor($rootScope, $scope, $state, $localStorage, $location, $timeout, AuthService) {
    this.name = "postingdropdown";
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$location = $location;
    this.$auth = AuthService;
    this.$localStorage = $localStorage;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.currentUser = this.$auth.getUserData();
    this.pt = this.currentUser.company.postingTypesAllowed;

    var _this = this;

    _this.SetNewPostTypesToHeaderLsitener = _this.$rootScope.$on("SetNewPostTypesToHeader", function (event, params) {
      _this.show_hide_posting_types(params);
    });

    _this.$scope.$on("$destroy", _this.SetNewPostTypesToHeaderLsitener);
    _this.setting_posting_types();
  }

  setting_posting_types() {
    var _this = this;
    if (!_this.currentUser.company.postingTypesAllowed) {
      _this.pt = 0;
    } else {
      _this.pt = _this.currentUser.company.postingTypesAllowed;
    }
  }

  go_to_post_event() {
    var _this = this;
    let page = _this.check_page(2);
    console.log("go_to_post_event");
    console.log(page);

    if (page.result === false) {
      _this.$timeout(function () {
        _this.$state.go("postevent", {pt: "ondemand"});
      });
    } else {
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetPostingTypeChange", page);
      });
    }
  }

  go_to_post_order() {
    var _this = this;
    let page = _this.check_page(1);
    if (page.result === false) {
      _this.$state.go("postorder");
    }
  }

  go_to_sourcing() {
    var _this = this;
    let page = _this.check_page(3);
    if (page.result === false) {
      _this.$state.go("postevent", {pt: "sourcing"});
    } else {
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetPostingTypeChange", page);
      });
    }
  }

  check_page(x) {
    var _this = this;
    let url = _this.$location.$$url;
    let output = {};
    output.result = null;
    if (url === "/post-event" && x === 3) {
      output.result = true;
      output.posting_type_set = "sourcing";
    } else if (url === "/post-event" && x === 2) {
      output.result = true;
      output.posting_type_set = "ondemand";
    } else if (url === "/post-event" && x === 1) {
      output.result = false;
      output.posting_type_set = "postorder";
    } else {
      output.result = false;
      output.type = x;
    }
    return output;
  }

  show_hide_posting_types(params) {
    var _this = this;
    _this.pt = params;
  }
}

PostingdropdownController.$inject = ["$rootScope", "$scope", "$state", "$localStorage", "$location", "$timeout", "auth"];

export default PostingdropdownController;



// WEBPACK FOOTER //
// ./client/app/common/jobbleheader/postingdropdown/postingdropdown.controller.js